export const QA_NAME_CALENDAR_ITEM_CARD_STEP_YES = 'calendarItemCardStepYes'

export const QA_NAME_CALENDAR_ITEM_CARD_STEP_NO = 'calendarItemCardStepNo'
